const isDev = import.meta.env.VITE_APP_MODE === 'development' || 
import.meta.env.MODE === 'development' || 
import.meta.env.DEV;


const logger = {
	log: (...args) => isDev && console.log(...args),
	warn: (...args) => isDev && console.warn(...args),
	error: (...args) => console.error(...args), // Ошибки оставляем для продакшена
}

export default logger
